export default __webpack_public_path__ + "static/media/c905a6df-d855-44d1-abaf-e662740ad467.5382be2d.woff2";